import { List as KoList } from 'antd';

export default KoList;